export default "__VITE_ASSET__B99M8V0n__"